import { debounceSync } from '@/services/debounce';
import { calculateRequiredRanges } from '../services/dataLoader';
import { calculateVisibleRows } from '../services/virtualScroll';

/**
 * Mixin for managing data loading in a virtual table.
 */
export default {
    data() {
        return {
            activeLoadingRanges: new Set(),
            initialLoadAttempted: false
        };
    },

    methods: {
        checkAndLoadVisibleRange(
            scrollTop,
            containerHeight,
            cellHeight,
            totalItems,
            items,
            activeRanges,
            onLoadRange
        ) {
            this.initialLoadAttempted = true;

            if (totalItems === 0 || containerHeight === 0) return;

            // Calculate visible rows
            const visibleRows = calculateVisibleRows(scrollTop, containerHeight, cellHeight, totalItems, items);

            if (visibleRows.length === 0) return;

            const firstVisible = visibleRows[0].index;
            const lastVisible = visibleRows[visibleRows.length - 1].index;

            // Get required ranges
            const ranges = calculateRequiredRanges(firstVisible, lastVisible, items, activeRanges, totalItems);

            // Request loading for each range
            ranges.forEach((range) => {
                const rangeKey = `${range.start}-${range.end}`;
                activeRanges.add(rangeKey);
                onLoadRange(range);
            });
        },

        debouncedCheckAndLoad: debounceSync(function(
            scrollTop,
            containerHeight,
            cellHeight,
            totalItems,
            items,
            activeRanges,
            onLoadRange
        ) {
            this.checkAndLoadVisibleRange(
                scrollTop,
                containerHeight,
                cellHeight,
                totalItems,
                items,
                activeRanges,
                onLoadRange
            );
        }, 50),

        updateLoadingRanges(loadedRanges, activeRanges) {
            // Remove completed ranges from active set
            activeRanges.forEach((rangeKey) => {
                const [start, end] = rangeKey.split('-').map(Number);
                const isLoaded = loadedRanges.some((loaded) => loaded.start <= start && loaded.end >= end);
                if (isLoaded) {
                    activeRanges.delete(rangeKey);
                }
            });
        },

        loadVisibleRange() {
            this.debouncedCheckAndLoad(
                this.scrollTop,
                this.containerHeight - this.headerHeight,
                this.cellHeight,
                this.totalItems,
                this.items,
                this.activeLoadingRanges,
                (range) => this.$emit('load-range', range)
            );
        }
    }
};
